import { z } from 'zod';
import { notificationConfigSchema } from './notification.js';
export const createLocationSchema = z.object({
    name: z.string().min(1).max(255),
    address_line1: z.string().max(255).optional(),
    address_line2: z.string().max(255).optional(),
    city: z.string().max(100).optional(),
    state: z.string().max(50).optional(),
    zip: z.string().max(20).optional(),
    country: z.string().length(2).default('US'),
    phone: z.string().max(20)
        .refine(val => !val || /^\(\d{3}\) \d{3}-\d{4}$/.test(val), {
        message: 'Phone must be (XXX) XXX-XXXX format',
    })
        .optional(),
    email: z.string().email().max(254).optional(),
    timezone: z.string().max(50).default('America/Chicago'),
    business_hours: z.record(z.object({ open: z.string(), close: z.string() })).optional(),
    social_links: z.record(z.string()).optional(),
    notification_config: notificationConfigSchema.optional(),
});
export const updateLocationSchema = createLocationSchema.partial();
//# sourceMappingURL=location.js.map